<template>
  <dx-facts-form
    next-step-path="SelfService-ReportDamage-DocumentUpload"
    previous-step-path="SelfService-ReportDamage-MyInfo"
  />
</template>

<script>
import DxFactsForm from '~/components/reportDamage/DX-FactsForm'

export default {
  name: 'ReportDamageFacts',
  components: {
    DxFactsForm,
  },
  layout: 'non-sticky-nav',
  nuxtI18n: {
    paths: {
      de: '/kundencenter/schaden-melden/sachverhalt',
      fr: '/centre-clients/dommages-rapport/realites',
      it: '/cliente/danni-report/fatti',
    },
  },
}
</script>
